import { CreateCompanyDTO, UpdateCompanyDTO } from '@redux/types/crm/companies/companiesTypes';
import { Company, CompanyTypes } from '@shared/models/company/company';
import { SavedViewType } from '@shared/models/saved_view/savedView';
import { IndexResponse } from '@shared/types/services';

// TODO: Move to shared/models/company/company.ts
export enum CompanyRoles {
  // Transaction
  Purchaser = 1,
  PurchaserAgent = 2,
  Vendor = 3,
  VendorAgent = 4,
  Landlord = 5,
  LandlordAgent = 6,
  Tenant = 7,
  TenantAgent = 8,
  TenantSolicitor = 14,
  LandlordSolicitor = 15,
  VendorSolicitor = 16,
  PurchaserSolicitor = 17,
  // Property
  Freeholder = 9,
  ManagingAgent = 10,
  FreeholderAgent = 40,
  FreeholderSolicitor = 41,
  Lessor = 42,
  // Acquisition
  AcquisitionTenant = 11,
  AcquisitionTenantIntel = 18,
  AcquisitionAgent = 13,
  // Disposal
  KeyContact = 12,
  Developer = 31,
  Architect = 32,

  LongLeaseholder = 20,
  LongLeaseholderAgent = 21,
  LongLeaseholderSolicitor = 22,
  JointAgent = 25,
  Client = 33,
  Other = 30,
}

// TODO: Move to shared/models/company/company.ts
export enum CompanyStatus {
  Active = 1,
  Inactive = 2,
}

// -- Queries --

export const companiesListFilterGroupKeys = [
  ['assigned_users', 'assigned_users_string'],
  ['investor_aum_from', 'investor_aum_to', 'investor_aum_currency'],
  ['created_ago', 'created_ahead', 'created_from', 'created_to'],
  ['updated_ago', 'updated_ahead', 'updated_from', 'updated_to'],
] as const;

export const companiesListFilterParamKeys = [
  ...companiesListFilterGroupKeys.flat(),
  'company_source',
  'country',
  'has_active_disposals',
  'has_active_leases',
  'has_active_requirements',
  'has_active_sales',
  'has_active_viewings',
  'has_investor_profile',
  'has_open_tasks',
  'location',
  'postcode',
  'sectors',
  'status',
  'tags',
  'type',
] as const;

export const companiesListParamKeys = [
  ...companiesListFilterParamKeys,
  'id',
  'limit',
  'order',
  'page',
  'search',
] as const;
export type CompaniesListParams = PartialQuery<typeof companiesListParamKeys>;

export interface CompaniesListPayload extends QueryPayload<CompaniesListParams> {
  viewType: SavedViewType;
}

export const companiesAcListFilterParamKeys = ['limit', 'search'] as const;

export const companiesAcListParamKeys = [...companiesAcListFilterParamKeys] as const;

export type CompaniesAcListParams = PartialQuery<typeof companiesAcListParamKeys>;

export type CompaniesAcListPayload = QueryPayload<CompaniesAcListParams>;

export type CompaniesResponse = IndexResponse<Company>;

export interface CompanyShowParams extends Query {
  with: string;
}

export interface CompanyShowPayload extends OptionalQueryPayload<CompanyShowParams> {
  id: string;
}

// -- Mutations --

export type CompanyCreatePayload = BodyPayload<Partial<CreateCompanyDTO>>;

export interface CompanyUpdatePayload extends BodyPayload<Partial<UpdateCompanyDTO>> {
  id: string;
}

export interface CompaniesCreateCommentDTO {
  comments: string;
}

export interface CompaniesCreateCommentPayload extends BodyPayload<CompaniesCreateCommentDTO> {
  id: string;
}

// -- Bulk Actions --

export interface CompaniesBulkUpdateStatusDTO {
  company_ids?: number[];
  filters?: Record<string, any>;
  status: CompanyStatus;
}

export type CompaniesBulkUpdateStatusPayload = BodyPayload<CompaniesBulkUpdateStatusDTO>;

export interface CompaniesBulkUpdateTypeDTO {
  company_ids?: number[];
  filters?: Record<string, any>;
  company_type: CompanyTypes[];
}

export type CompaniesBulkUpdateTypePayload = BodyPayload<CompaniesBulkUpdateTypeDTO>;

export interface CompaniesBulkUpdateTagsDTO {
  company_ids?: number[];
  filters?: Record<string, any>;
  tags: number[];
}

export type CompaniesBulkUpdateTagsPayload = BodyPayload<CompaniesBulkUpdateTagsDTO>;

export interface CompaniesBulkDeleteDTO {
  company_ids?: number[];
  filters?: Record<string, any>;
  archive_requirements: boolean;
}

export type CompaniesBulkDeletePayload = BodyPayload<CompaniesBulkDeleteDTO>;
